import { Element } from "@api/models/Element";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import store from "@service/store";
import Vue from "vue";
import { ArrayHelpers } from "@common/ArrayHelpers";

export class ExhibitionsListHelper {
    private _list: Record<string, Record<string, Element>> = {};
    private readonly _schemaId: string = '';

    constructor(
        private readonly repository: ObjectRepository
    ) {
        this._schemaId = process.env.VUE_APP_EXHIBITION_SCHEMA! || "Exhibition";
    }

    get list() {
        return this._list;
    }

    get schemaId() {
        return this._schemaId;
    }

    async load(eventId: string) {
        if (!eventId) { return; }

        try {
            const result = await this.repository.query(this._schemaId, { take: -1,
                skip: 0,
                where: {
                    eventId: eventId
                }
            });

            Vue.set(this._list, eventId, ArrayHelpers.keyBy(result, 'id'));
        }
        catch (e) {
            store.dispatch('reportException', e);
        }
    }

    private hasEvent(eventId: string) {
        return Object.prototype.hasOwnProperty.call(this._list, eventId);
    }

    delete(eventId: string, exhibitionId: string) {
        if (!this.hasEvent(eventId)) { return; }

        if (!this._list[eventId][exhibitionId]) { return; }

        Vue.delete(this._list[eventId], exhibitionId);
    }

    update(exhibition: Element) {
        if (!this.hasEvent(exhibition.eventId)) { return; }

        Vue.set(this._list[exhibition.eventId], exhibition.id, exhibition);
    }
}
